module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ctl",
    attrs: {
      "id": "d12e290"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Wals_ISBN1418537640_epub_c4_r1#d12e120",
      "id": "d12e291"
    }
  }, [_vm._v("introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "h2l",
    attrs: {
      "id": "d12e293"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Wals_ISBN1418537640_epub_c4_r1#d12e120",
      "id": "d12e294"
    }
  }, [_vm._v("God Is Listening")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d12e296"
    }
  }, [_vm._v("If you had asked me to describe my spiritual life when I was twenty years old, it would have sounded something like this: I love to read the Bible. I love reading spiritual classics. I am very involved in my church. And I am challenged in my prayer life.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e298"
    }
  }, [_vm._v("At thirty, I would have said pretty much the same thing, except in regard to prayer I might have reduced “I am challenged” to “I stink.” (I was beginning to be more honest about my life in my thirties.) But otherwise the facts would remain intact.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e300"
    }
  }, [_vm._v("At forty, I would have added that I love talking to women about faith and fear, honesty and heartache. And I had pretty much resigned myself to “stinking” in my prayer life.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e302"
    }
  }, [_vm._v("And now? Well, now I am fifty, and change in every arena of life has become an ongoing reality.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e304"
    }
  }, [_vm._v("My eyesight has deteriorated to the shifting terrain of bifocals. At my last eye test, when the optometrist covered my left eye, I could only read the first two lines on the chart. When he covered my right eye, I couldn’t see the wall!")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e306"
    }
  }, [_vm._v("I am definitely getting shorter. To remedy this, I have two clear choices: wear higher heels or have all my pants altered.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e308"
    }
  }, [_vm._v("I need my roots retouched every three weeks now instead of every six. When I suggested going back to my natural color, my hair-stylist said I no longer have one. Who knew that was even possible? ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e310"
    }
  }, [_vm._v("But in the midst of all these unsettling changes, I am discovering profound and simple gifts that have come with the passing years. For example, I don’t worry so much about the little things in life. If my son and four of his ten-year-old friends decide to make a fort in the kitchen just as I’m about to make dinner, I switch the menu to franks and beans and serve it to them in the tent. And when unexpected troubles come my way, I’ve learned I have good friends—friends I can count on. We love, treasure, and support one another. We laugh at all the petty indignities of aging and cry together when life takes one of us through a dark night.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e312"
    }
  }, [_vm._v("I am changing in my understanding of my spiritual life too. I am more inclined to listen for God’s voice than to present to him a list of requests. I have a quiet confidence that no matter what seems to be true, God is always in control.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e315"
    }
  }, [_vm._v("Most important, I have realized that it is not possible to stink at prayer. It might feel that way to us at times, but I believe that from God’s perspective, he gladly receives our words and he sees our hearts. Any prayer is a gift to him, for it means we are talking to him. We just have to take that first step—and begin embracing prayer as part of our daily lives, as vital to us as breathing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e317"
    }
  }, [_vm._v("I no longer divide my life into the spiritual part and everything else. I believe when we recognize God is always with us, every breath can be a prayer. Prayer is not just a few sentences we say to God while on our knees, but it is living out our ongoing, every-moment commitment to God—hence the title: "), _c('i', [_vm._v("Get Off Your Knees and Pray! ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e321"
    }
  }, [_vm._v("Perhaps you’re thinking, "), _c('i', [_vm._v("Prayer is easy—we were made to rejoice ")]), _c('i', [_vm._v("in our relationship with God and to thank him for his gifts. ")]), _vm._v("Well, sure, it’s always easy to be thankful for God’s good gifts. But what about when we’re not thankful? What about when we’re hurt? Angry? Numb? Is it so easy then?")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e328"
    }
  }, [_vm._v("It might not be so easy, but he wants it to be our first response. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e330"
    }
  }, [_vm._v("Or perhaps you’re thinking, "), _c('i', [_vm._v("Prayer has never been easy for me. I ")]), _vm._v("do "), _c('i', [_vm._v("stink at it! ")]), _vm._v("You feel like what you say to him is insincere, unsure. Or you question whether he even really cares to hear from you. Or you’re so overwhelmed you don’t even want to talk to him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e338"
    }
  }, [_vm._v("It isn’t. He does. He still wants you to.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e340"
    }
  }, [_vm._v("God hears all our prayers, the good and the bad. He is big enough to handle our honest questions and our doubts and even our anger. I sat beside a friend after she buried her child and listened as she poured out her raw emotions to God. Her prayer wasn’t pretty, but it was from her heart and God knew it. I watched my son struggle with prayer after the death of his beloved grandfather: “Didn’t you tell me, Mommy, that if I prayed God would answer? Well, I asked him not to take my papa and he did. Prayer doesn’t work!” It hurt me immeasurably to see his pain, but I knew God was there with him. And I’ve blasted God with my own prayer challenges . . . and mumbled to him my doubts. And I know he heard me. He has heard you too.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e342"
    }
  }, [_vm._v("God receives our prayers—the thankful ones and the not-so-thankful ones, the eloquent ones and the less-than-perfect ones. He accepts not only our joyful prayers and self-confident prayers, but the prayers we offer when we’re not certain of things—or when we’re not sure we really want the answer. He accepts our anguished questioning when we experience trauma or loss. He even accepts the prayers that beg him to rain down disaster on someone who has wounded us (although he may not answer them). He accepts all our prayers because they acknowledge we believe he is in control. When we’re happy, when we’re angry, when we’re hurting to the point that words are lost and all we can offer is a cry for help—he is still there.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e344"
    }
  }, [_vm._v("God is listening.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e346"
    }
  }, [_vm._v("This sharpening of my spiritual vision seemed to arrive at about the same time God deposited a seven-pound, eight-ounce beautiful baby boy into my arms. Becoming a mother ten years ago at forty affected my life in more ways than I imagined possible. (On a purely practical note, I now believe I should have slept more the first forty years!) As a new mom, I was humbled to realize that even the most insecure or guarded of us can love selflessly when we look into the eyes of our child. And I got a huge kick out of the fact that a girl like me, who was afraid of being beaten up on the school bus, could love my child so fiercely that I would rip the legs off a lion if it came near my son.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e348"
    }
  }, [_vm._v("But more than that, having a child changed the way I viewed my relationship—my ongoing prayer conversation—with God.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e351"
    }
  }, [_vm._v("I remember my friend Amy Grant saying that when her first son, Matt, was born, she realized that for the rest of her life her heart would walk outside of her body. I didn’t understand the accuracy of that statement until my son, Christian, was born. Since then my life has changed in obvious ways and in ways that are more difficult to articulate.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e353"
    }
  }, [_vm._v("Often, when Christian is asleep at night, I will stand at the side of his bed and marvel at the gift he is to me. I began this practice when he was just a baby. Before motherhood I had no idea that I could feel the depth of love that would consider any kind of sacrifice a privilege. But as I watched over my son, I came to an acute new awareness of our heavenly Father watching over us. And I began to understand the depth of his love for us.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e355"
    }
  }, [_vm._v("Because of this, my prayer life changed. I loved talking to and listening to God. I loved talking to him all the time. (I still do!) And being honest with him. Being a sleep-deprived mother of a baby in those early days eliminated much of the preamble in my conversation with God; I just got right to the point.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e357"
    }
  }, [_vm._v("Having my son face a life-threatening illness sharpened my dialogue too. Further tests revealed he was anemic rather than suffering from leukemia, but being in that terrifying place for a few days changed me. I was not so careful about the potential of offending God. I was afraid, I was angry, and I was honest. It felt good to relate to God in that authentic way.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e359"
    }
  }, [_vm._v("It still does. I could never go back to my old, edited prayers. I think it would be a huge insult to God. Raw emotion declares that you trust him with everything that is in you, knowing he will still be there when the outburst is over. When I share my fear and my anger and my uncertainty when it is most acute, I also pour out my love and gratitude with more passion. Real relationship demands intimate dialogue. Even if it’s just lying facedown on the carpet calling out his name with your last ounce of strength.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e361"
    }
  }, [_vm._v("Within the pages of this book is an invitation to pour your-self out—heart and soul—to God, to experience what I’ve come to know and embrace. I spent so much of my life trying to be “good enough” for God. I wanted to get all my spiritual ducks in a row before I came to him. That is a lonely way to live. We have been created for intimate conversation with our Father. The greatest source of joy and peace in my life today is the absolute conviction that I can come to God as I am and be loved and accepted. I can tell God my hopes and dreams, share my disappointments and hurts.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e363"
    }
  }, [_vm._v("This invitation comes with a disclaimer, however: I don’t profess to have all knowledge. Much about prayer is still a mystery to me. I have more questions than I have answers: Can we change God’s mind? . . . If God is sovereign and has already set everything in place, why bother praying? . . . Why does it seem as if some people’s prayers are answered and others’ are not? . . . How does the level of my faith affect the outcome of my prayers?")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e365"
    }
  }, [_vm._v("Yes, there are many questions, but that’s okay. My plea to you even in the midst of the questions is simple: talk to God and take time to listen. No matter how “vertically challenged” we may believe ourselves to be, God is listening and talking to us all the time. We only need to learn to stop and listen.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e367"
    }
  }, [_vm._v("We are living in difficult times. War and terrorism are no longer a million miles away from home. Cancer and heart disease are waging an unprecedented battle against younger and younger people. The financial “golden days” of the 1980s are long gone. People worry if they will have enough savings to help their children through college or if they themselves will have enough to retire on. The bottom line is, life is hard.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e369"
    }
  }, [_vm._v("God knows all about it. And more than that, right in the center of the tornado of our lives, he offers a quiet place, a shelter where he waits with open arms and an open heart to embrace any of us who will come. Whether you are young or old, full of hope or full of fear, angry or excited, bitter or grateful, this remains my conviction: God is listening.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e371"
    }
  }, [_vm._v("So let’s begin this journey and explore how to recognize the hand of God in every moment. Whether we’re on or off our knees—let’s pray! ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4788be24","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Wals_ISBN1418537640_epub_c6_r1.vue
// module id = 72
// module chunks = 0